"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const theme_1 = require("../../theme/theme");

const SvgBox = props => {
  const stroke = props.stroke || theme_1.mainTheme.colors.primary_700_main;
  return (0, jsx_runtime_1.jsx)("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 27,
    fill: "none"
  }, props, {
    children: (0, jsx_runtime_1.jsx)("g", Object.assign({
      id: "Layer_2",
      "data-name": "Layer 2"
    }, {
      children: (0, jsx_runtime_1.jsxs)("g", Object.assign({
        id: "Layer_1-2",
        "data-name": "Layer 1"
      }, {
        children: [(0, jsx_runtime_1.jsx)("polygon", {
          points: "35.49 4.24 35.49 1.24 33.99 1.24 33.99 4.24 30.99 4.24 30.99 5.74 33.99 5.74 33.99 8.74 35.49 8.74 35.49 5.74 38.49 5.74 38.49 4.24 35.49 4.24",
          fill: stroke
        }, void 0), (0, jsx_runtime_1.jsx)("path", {
          d: "M34,23.84a1.66,1.66,0,0,1-1.66,1.66H3.16A1.66,1.66,0,0,1,1.5,23.84V7.41A1.67,1.67,0,0,1,3.16,5.75h4.6A3.15,3.15,0,0,0,10.59,4l.79-1.58a1.64,1.64,0,0,1,1.49-.92h9.76a1.64,1.64,0,0,1,1.49.92L24.91,4a3.15,3.15,0,0,0,2.83,1.75H29.5V4.25H27.74a1.66,1.66,0,0,1-1.49-.92l-.79-1.58A3.14,3.14,0,0,0,22.63,0H12.87A3.14,3.14,0,0,0,10,1.75L9.25,3.33a1.66,1.66,0,0,1-1.49.92H3.16A3.17,3.17,0,0,0,0,7.41V23.84A3.17,3.17,0,0,0,3.16,27H32.34a3.17,3.17,0,0,0,3.16-3.16V10.25H34Z",
          fill: stroke
        }, void 0), (0, jsx_runtime_1.jsx)("path", {
          d: "M17.75,7.16a7.41,7.41,0,1,0,7.4,7.4A7.41,7.41,0,0,0,17.75,7.16Zm0,13.31a5.91,5.91,0,1,1,5.9-5.91A5.91,5.91,0,0,1,17.75,20.47Z",
          fill: stroke
        }, void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};

exports.default = SvgBox;